// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instructionwidget_sections_definitions__vq0cs{
    flex-direction: row;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
    border: 0.5px;
    border-style:solid;
    margin-top: 10px;
    white-space: pre-wrap ; 

    border-color: var(--hsrcInactive);
    border-radius: 8px;

    page-break-inside: avoid;

    break-inside: avoid-page;
  }

  .instructionwidget_sections_definitions_left__xFby9{
    flex-direction: row;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
  }

  .instructionwidget_sections_definitions_right__8j4aZ{
    flex-direction: column;
    width: 50%;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: center;
  }

  .instructionwidget_sections_text__\\+O6X8 {
    color:   var(--hsrcInactive) ; 
    filter: brightness(0.85);
    font-size: 14px;
    padding: 20px;
  }
`, "",{"version":3,"sources":["webpack://./src/components/InstructionWidget/instructionwidget.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;;IAEtB,iCAAiC;IACjC,kBAAkB;;IAElB,wBAAwB;;IAAxB,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,wBAAwB;IACxB,eAAe;IACf,aAAa;EACf","sourcesContent":[".sections_definitions{\r\n    flex-direction: row;\r\n    align-items: flex-start;\r\n    align-content: flex-start;\r\n    justify-content: flex-start;\r\n    border: 0.5px;\r\n    border-style:solid;\r\n    margin-top: 10px;\r\n    white-space: pre-wrap ; \r\n\r\n    border-color: var(--hsrcInactive);\r\n    border-radius: 8px;\r\n\r\n    break-inside: avoid-page;\r\n  }\r\n\r\n  .sections_definitions_left{\r\n    flex-direction: row;\r\n    align-items: flex-start;\r\n    align-content: flex-start;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .sections_definitions_right{\r\n    flex-direction: column;\r\n    width: 50%;\r\n    align-items: flex-start;\r\n    align-content: flex-start;\r\n    justify-content: center;\r\n  }\r\n\r\n  .sections_text {\r\n    color:   var(--hsrcInactive) ; \r\n    filter: brightness(0.85);\r\n    font-size: 14px;\r\n    padding: 20px;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sections_definitions": `instructionwidget_sections_definitions__vq0cs`,
	"sections_definitions_left": `instructionwidget_sections_definitions_left__xFby9`,
	"sections_definitions_right": `instructionwidget_sections_definitions_right__8j4aZ`,
	"sections_text": `instructionwidget_sections_text__+O6X8`
};
export default ___CSS_LOADER_EXPORT___;
